import CandidateTile from './CandidateTile';

export default CandidateTile;
export * from './CandidateTile';
